import Vue from "vue";
Vue.filter("limitText", (value, limit = 10) => {
  return value.length > limit
    ? `${value.substring(0, limit).replace(/\.|\s$/g, "")}...`
    : value;
});
